/* STATUS CONSTANT */
export const STATUS_TYPE = {
  0: 'Ativo',
  1: 'Inativo',
  2: 'Expirado',
}

/* REPORT TYPES CONSTANT */
export const REPORT_TYPES = {
  0: 'Ruptura',
  2: 'Gestão Comercial',
}

/* System dates pattern */
export const FORMAT_DATE_TRUNC = 'DD/MM/YYYY'
export const FORMAT_DATE_T = 'YYYY-MM-DDT03:00:00'
export const FORMAT_DATETIME_TRUNC = 'DD/MM/YYYY HH:mm:ss'
export const FORMAT_HOUR = 'HH:mm:ss'

/* Rupture type */
export const RUPTURE_TYPE = {
  LMS: 1,
  SALES: 2,
  TOTAL: 3,
  TOP2500: 4,
}

/* Code Type 8 */
export const CODE8_TYPE = {
  LMS: 1,
  SALES: 2,
}

/* Lm Express Type */
export const LMEXPRESS_TYPE = {
  CLIENTS: 1,
  LMS: 2,
  SECTIONS: 3,
}

export const DEPARTMENTS = {
  2: 'sectionId',
  3: 'subSectionId',
  4: 'typeId',
  5: 'subTypeId',
}

export const PARAMETER_TYPE = {
  1: 'option.string',
  2: 'option.integer',
  3: 'option.date',
  4: 'option.dateTime',
  5: 'option.decimal',
  6: 'option.blob',
  7: 'option.boolean',
  8: 'option.long',
}

export const STATUS_TYPE_INVERTED = {
  0: 'option.active',
  1: 'option.inactive',
  '': 'option.all',
}

export const JUSTIFICATION_TYPE = {
  DISPARITY: 1,
  UNCOUNT: 2,
}
